/** Motionless / CloudFront — Aurora-Layout (Login + Hero-Experiment). */
export const AURORA_AUTH_VIDEO_SRC =
  'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260506_081238_406ed0e3-5d83-436e-a512-0bbff7ec5b95.mp4';

/** Ursprüngliches Hero-Video. */
export const T05_HERO_VIDEO_SRC =
  'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260629_021419_291eb2af-5ed4-45a0-a1d6-3ef58f4bca0b.mp4';

/** @deprecated Mux-HLS war auf großen Screens zu pixelig — Sektions-BG ist jetzt rein CSS. */
export const T05_SECTION_BG_HLS_SRC =
  'https://stream.mux.com/NcU3HlHeF7CUL86azTTzpy3Tlb00d6iF3BmCdFslMJYM.m3u8';

/** @deprecated Alias — gleiche Quelle wie T05_SECTION_BG_HLS_SRC */
export const T05_STARS_HLS_SRC = T05_SECTION_BG_HLS_SRC;
/**
 * Optional: progressives MP4 statt HLS (flüssiger). Sonst `null`.
 */
export const T05_SECTION_BG_MP4_SRC: string | null = null;

/** @deprecated Alias */
export const T05_STARS_MP4_SRC = T05_SECTION_BG_MP4_SRC;